/**
 * Vee-Validate, Vuelidate, or Simple Vue Validator
 * @see https://medium.com/thetribeio/vue-js-form-validation-fd9113e09701
 *
 * @see https://vuejs.org/v2/guide/mixins.html
 * @see https://vuetifyjs.com/en/components/forms/#validation-with-submit-clear
 *
 * @see Vuelidate - https://vuelidate.js.org/
 * @see VeeValidate - https://logaretm.github.io/vee-validate/
 *
 */
import validationService from '../services/validationService';
import {isObject} from 'lodash';

export default {
  data: () => ({
    rules: {
      required: value => !!value || 'Required.',
      email: v => validationService.isEmailValid(v) || 'Email must be valid.',
      objectEmail: v => { // MLD-2279
        if (isObject(v)) {
          return validationService.isEmailValid(v.email) || 'Email must be valid.';
        } else {
          return validationService.isEmailValid(v) || 'Email must be valid.';
        }
      }
    }
  }),
  methods: {
    validateForm(form = 'form') {
      return this.$refs[form].validate();
    },
    resetForm(form = 'form') {
      this.$refs[form].reset();
    },
    resetFormValidation(form = 'form') {
      this.$refs[form].resetValidation();
    },
  }
}
